import React, { useEffect } from 'react'
import { API_CONFIG } from '../../config/api.config'

// Xác nhận Họ tên / Lớp / Môn khi nộp (online + phiếu giấy) → lưu kèm bài làm cho GV và HS xem.
// Nhớ lần nhập trước trên máy; họ tên lần đầu lấy từ tài khoản.

export interface Identity { name: string; className: string; subject: string }

export const SUBJECTS = ['Vật lí', 'Toán', 'Hoá học', 'Sinh học', 'Tiếng Anh', 'Ngữ văn', 'Lịch sử', 'Địa lí',
  'Tin học', 'Công nghệ', 'GD Kinh tế và Pháp luật']

const KEY = 'exam_identity'

export function loadIdentity(subject?: string): Identity {
  let saved: Partial<Identity> = {}
  try { saved = JSON.parse(localStorage.getItem(KEY) || '{}') } catch { /* bỏ qua */ }
  return { name: saved.name || '', className: saved.className || '', subject: subject || saved.subject || 'Vật lí' }
}

export function saveIdentity(v: Identity) {
  try { localStorage.setItem(KEY, JSON.stringify(v)) } catch { /* bỏ qua */ }
}

export const identityOk = (v: Identity) => v.name.trim().length >= 2 && v.className.trim().length >= 1 && !!v.subject.trim()

/** Trường gửi kèm /pmaker-advanced/submit */
export const identityPayload = (v: Identity) => ({
  student_name: v.name.trim(), class_name: v.className.trim(), subject: v.subject.trim(),
})

export const SubmitIdentityFields: React.FC<{ value: Identity; onChange: (v: Identity) => void }> = ({ value, onChange }) => {
  // Chưa có họ tên → lấy tên tài khoản
  useEffect(() => {
    if (value.name) return
    const t = localStorage.getItem('jwt_token')
    if (!t) return
    fetch(`${API_CONFIG.python.apiUrl}/users/me`, { headers: { Authorization: `Bearer ${t}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((u) => { if (u?.name) onChange({ ...value, name: u.name }) })
      .catch(() => { /* bỏ qua */ })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const input = 'w-full px-3 py-2 rounded-lg border border-slate-300 bg-white text-slate-800 text-base'
  return (
    <div className="rounded-xl border border-teal-200 bg-teal-50/60 p-3 space-y-2 text-left">
      <p className="text-sm font-bold text-teal-800">Kiểm tra lại thông tin trước khi nộp</p>
      <label className="block text-sm text-slate-700">Họ và tên
        <input value={value.name} onChange={(e) => onChange({ ...value, name: e.target.value })} placeholder="Nguyễn Văn A" className={input} />
      </label>
      <div className="grid grid-cols-2 gap-2">
        <label className="block text-sm text-slate-700">Lớp
          <input value={value.className} onChange={(e) => onChange({ ...value, className: e.target.value })} placeholder="12A1" className={input} />
        </label>
        <label className="block text-sm text-slate-700">Môn
          {/* Danh sách thả xuống (iPhone không hiện gợi ý kiểu datalist); mặc định = môn GV đặt cho đề */}
          <select value={value.subject} onChange={(e) => onChange({ ...value, subject: e.target.value })} className={input}>
            {(SUBJECTS.includes(value.subject) ? SUBJECTS : [value.subject, ...SUBJECTS]).map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </label>
      </div>
      {!identityOk(value) && <p className="text-xs font-semibold text-rose-600">Hãy nhập đủ họ tên và lớp.</p>}
    </div>
  )
}
